import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "switch" }
const _hoisted_3 = { class: "slider" }
const _hoisted_4 = { class: "switch-text-left" }
const _hoisted_5 = { class: "switch-text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("input", {
        id: "slider",
        type: "checkbox",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSwitch($event)))
      }, null, 32),
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title.left), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.title.right), 1)
      ])
    ])
  ]))
}